export function getDishFeedbackLink(feedbackId: string): string {
  return `/nutrition/feedback?${new URLSearchParams({ feedbackId })}`;
}
